module.exports = __webpack_public_path__ + "static/media/quality.67d91ddd.svg";